export default function (nga, admin, activities, groups) {
    var exercise = admin.getEntity('periodic_events');
    exercise.listView()
        .title('{{ "Periodic Events" | translate }}')
        .fields([
            nga.field('group_id', 'reference')
                .targetEntity(groups)
                .targetField(nga.field('name'))
                .label('Group'),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity'),
            nga.field('start_time').
                map(function(a, values){
                    var hour = values['start_time.hour'];
                    var minute = values['start_time.minute'];
                    return hour + ':' + (minute < 10 ? '0' + minute : minute);;
                }),
            nga.field('end_time').
                map(function(a, values){
                    var hour = values['end_time.hour'];
                    var minute = values['end_time.minute'];
                    return hour + ':' + (minute < 10 ? '0' + minute : minute);;
                }),
            nga.field('exercises_count', 'number'),
            nga.field('monday', 'boolean').label('M'),
            nga.field('tuesday', 'boolean').label('T'),
            nga.field('wednesday', 'boolean').label('W'),
            nga.field('thursday', 'boolean').label('R'),
            nga.field('friday', 'boolean').label('F'),
            nga.field('saturday', 'boolean').label('S'),
            nga.field('sunday', 'boolean').label('U')
        ]).filters([
            nga.field('group_id', 'reference')
                .targetEntity(groups)
                .targetField(nga.field('name'))
                .label('Group')
        ])
        .sortField('group_id')
        .sortDir('DESC')
        .actions(['create', 'filter'])
        .listActions(['edit']);
    exercise.creationView()
        .fields([
            nga.field('group_id', 'reference')
                .targetEntity(groups)
                .targetField(nga.field('name'))
                .label('Group')
                .validation({ required: true }),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity')
                .validation({ required: true }),
            nga.field('exercises_count', 'number'),
            // FIXME: format start_time/end_time or use a custom component
            nga.field('start_time')
                .map(function(a, values){
                    var hour = values['start_time.hour'];
                    var minute = values['start_time.minute'];
                    return hour + ':' + (minute < 10 ? '0' + minute : minute);;
                })
                .validation({ required: true, pattern: /([01]\d|2[0-3]):([0-5]\d)/ })
                .label('Start Time (hh:mm)'),
            nga.field('end_time')
                .map(function(a, values){
                    var hour = values['end_time.hour'];
                    var minute = values['end_time.minute'];
                    return hour + ':' + (minute < 10 ? '0' + minute : minute);;
                })
                .validation({ required: true, pattern: /([01]\d|2[0-3]):([0-5]\d)/ })
                .label('End Time (hh:mm)'),
            nga.field('monday', 'boolean').validation({ required: true }),
            nga.field('tuesday', 'boolean').validation({ required: true }),
            nga.field('wednesday', 'boolean').validation({ required: true }),
            nga.field('thursday', 'boolean').validation({ required: true }),
            nga.field('friday', 'boolean').validation({ required: true }),
            nga.field('saturday', 'boolean').validation({ required: true }),
            nga.field('sunday', 'boolean').validation({ required: true })
        ])
    exercise.editionView()
        .title('{{ "EDIT" | translate }}')
            .fields(exercise.creationView().fields())

    return exercise;
}



// WEBPACK FOOTER //
// ./js/periodic_events/config.js